import { useEffect, useState, useRef } from "preact/hooks";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import { usePromoBannerSettings } from "~/hooks/use-promo-banner-settings.ts";
import { sanitizeRichTextHtml } from "~/utils/sanitize-rich-text-html.ts";

function PromoBanner() {
	const t = useTranslator();
	const settings = usePromoBannerSettings();
	const [isDismissed, setIsDismissed] = useState(false);
	const bannerRef = useRef<HTMLDivElement>(null);

	// Update body class and CSS variable for header positioning
	useEffect(() => {
		if (!settings || isDismissed || !bannerRef.current) {
			document.body.classList.remove("has-promo-banner");
			document.documentElement.style.removeProperty("--promo-banner-height");
			return;
		}

		document.body.classList.add("has-promo-banner");
		const height = bannerRef.current.offsetHeight;
		document.documentElement.style.setProperty(
			"--promo-banner-height",
			`${height}px`,
		);

		return () => {
			document.body.classList.remove("has-promo-banner");
			document.documentElement.style.removeProperty("--promo-banner-height");
		};
	}, [settings, isDismissed]);

	if (!settings || isDismissed) {
		return null;
	}

	const sanitizedHtml = sanitizeRichTextHtml(settings.htmlContent);

	return (
		<div ref={bannerRef} className="promo-banner">
			<div
				className="promo-banner__content"
				dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
			/>
			<button
				type="button"
				className="promo-banner__close-btn"
				onClick={() => setIsDismissed(true)}
				aria-label={t("Close banner")}
			>
				×
			</button>
		</div>
	);
}

export default PromoBanner;
